import axios from 'axios';

import RequestCachedError from '../errors/requestCachedError';
import cacheService from './cacheService';
import log from './logger/log';
import networkStatusService from './networkStatusService';

export const sendRequest = async ({
    config,
    isOffline,
    isOnlineRequest,
    isOfflineResponse,
    isWaitingCache,
    isCached,
    args,
    logPrefix,
}) => {
    const {url} = config;

    if (isOffline || isCached) {
        if (isOnlineRequest) {
            await cacheService.cacheRequest(url, args);

            throw new RequestCachedError();
        }

        if (isOfflineResponse) {
            return await cacheService.getCachedResponse(url);
        }
    }

    let response;

    try {
        response = await axios(config);
    } catch (e) {
        if (isOfflineResponse && networkStatusService.getIsOfflineError(e)) {
            log.warn(`${logPrefix}: Network error, using cached response. Url: ${url}`);

            return await cacheService.getCachedResponse(url);
        }

        throw e;
    }

    const {data} = response;

    if (isOfflineResponse) {
        if (isWaitingCache) {
            await cacheService.cacheResponse(url, data);
        } else {
            cacheService.cacheResponse(url, data);
        }
    }

    return data;
};
